import React from "react";
import ThumbImg from "../../../assets/img/png/thumbimg.png";
import Time from "../../../assets/img/png/Time.png";
import JobImg from "../../../assets/img/png/jobimg.png";

const TotalJobGraph = ({ dashBoardLoading, clientDashboard }) => {
  return (
    <div className="col-xxl-3 mt-3 mt-md-0 col-md-6">
      <div className="d-flex p-3 h-100 justify-content-between align-items-center box-shadow br-10 bg-white ">
        <div>
          <p className="common-text ">Total Jobs</p>
          <div className="d-flex align-items-center">
            <div className="common-heading-Medium   d-flex align-items-center">
              <div className="smile-icon">
                <img src={ThumbImg} alt="" />
              </div>
              <h2 className="common-heading-Medium  ms-2 mb-0">
                {dashBoardLoading ? (
                  <span className="common-text fs-xs-14 fw-bold text-black mb-0 ">
                    Loading
                  </span>
                ) : (
                  clientDashboard.total_job
                )}
              </h2>
            </div>
            <div className="common-heading-Medium ms-xlg-3 ms-2 d-flex align-items-center">
              <div className="smile-icon">
                <img src={Time} alt="" />
              </div>
              <h2 className="common-heading-Medium  ms-2 mb-0 ">
                {dashBoardLoading ? (
                  <span className="common-text fs-xs-14 fw-bold text-black mb-0 ">
                    Loading
                  </span>
                ) : (
                  clientDashboard.ongoing_job
                )}
              </h2>
            </div>
          </div>
        </div>
        <span
          className="rounded-50 dashboard-icon d-inline-block "
          style={{
            backgroundColor: "#e7f2fe",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundImage: `url(${JobImg})`,
          }}
        ></span>
      </div>
    </div>
  );
};

export default TotalJobGraph;
